import { log } from 'log';
import uuid from 'uuid-random';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useOnClose } from 'js/components/common/PopupManager';
import { useTranslations } from '../../../../../../hooks/i18n';

import { showGeoComplyPopupAction } from '../../../actions';

export const GEOFENCING_NATIVE_POPUP_ID = uuid();

export const useOnError = ({ transactionID, setShowOverlay, useTransparentPopup }) => {
    const onClose = useOnClose();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const dispatch = useDispatch();
    const t = useTranslations();

    return useCallback(async (errorCode, message) => {
        log('gcErr', { transactionID, errorCode });

        switch (errorCode) {
            default:
                setShowOverlay(false);
                dispatch(showGeoComplyPopupAction({
                    id: GEOFENCING_NATIVE_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: t(`playtech.mobile.system.geocomply.popups.error.${errorCode}`, message),
                    isModal: true,
                    buttons: [
                        {
                            onClick: onClose,
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        },
                        {
                            onClick: onRefresh,
                            text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                            color: 'info'
                        }
                    ],
                    useTransparentPopup
                }));

                try {
                    await validateGeolocation(null, null, null, transactionID, errorCode, 'geocomply');
                } catch (e) {
                    // noop
                }
        }
    }, [
        t,
        onClose,
        onRefresh,
        transactionID,
        dispatch,
        setShowOverlay,
        useTransparentPopup
    ]);
};
